import client, { Microservice } from '../utils/http.utils';

import {
  AgencyWithdrawalBreakdownAPI,
  InfluencerWithdrawalBreakdownAPI,
  WithdrawalBreakdown,
} from '../store/Wallet/store';

import {
  transformAgencyWithdrawalBreakdownPayload,
  transformInfluencerWithdrawalBreakdownPayload,
} from '../store/Wallet/payload';

export enum FileUploadIdPaymentType {
  BONUS = 'fixed_payment',
  COMMISSION = 'commission_payment',
}

export const RequestHasPendingWithdrawal = async (
  currency: string,
  id: string
): Promise<boolean> => {
  return await client.request(
    Microservice.TRANSACTION,
    `/wallet_balance/currency/${currency}/influencer/${id}/pending_withdrawal`,
    'GET'
  );
};

export const RequestAgencyHasPendingWithdrawal = async (
  currency: string,
  id: string
): Promise<boolean> => {
  return await client.request(
    Microservice.TRANSACTION,
    `/wallet_balance/currency/${currency}/agent/${id}/pending_withdrawal`,
    'GET'
  );
};

export const RequestGetInfluencerWithdrawalBreakdownAsync = async (
  withdrawalId: string
): Promise<WithdrawalBreakdown> => {
  const response: InfluencerWithdrawalBreakdownAPI = await client.request(
    Microservice.TRANSACTION,
    `/withdrawal/${withdrawalId}/details/influencer`,
    'GET'
  );
  return transformInfluencerWithdrawalBreakdownPayload(response);
};

export const RequestGetAgencyWithdrawalBreakdownAsync = async (
  withdrawalId: string
): Promise<WithdrawalBreakdown> => {
  const response: AgencyWithdrawalBreakdownAPI = await client.request(
    Microservice.TRANSACTION,
    `/withdrawal/${withdrawalId}/details/agency`,
    'GET'
  );
  return transformAgencyWithdrawalBreakdownPayload(response);
};

export const RequestGetTermsVerificationAsync = async (
  userId: string,
  userType: 'influencer' | 'agency'
) => {
  return await client.request<boolean>(
    Microservice.TRANSACTION,
    `/tax_information/terms_verification/user/${userId}/type/${userType}`,
    'GET'
  );
};

export const RequestGetFileuploadIdAsync = async (
  paymentId: string,
  paymentType: FileUploadIdPaymentType
) => {
  return await client.request<{ file_id: string }>(
    Microservice.TRANSACTION,
    `/selfbilled_invoice/payment/${paymentId}/type/${paymentType}`,
    'GET'
  );
};

export const RequestPutSelfbillAgreementConfirmation = async () => {
  await client.request(
    Microservice.TRANSACTION,
    `/selfbilled_invoice/terms/agreement/confirmation`,
    'PUT'
  );
};
